import '../../../src/component/edit.css';
import { useEffect, useState, useRef} from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { editSectionThree } from '../../features/dashboard/SectionThreeSlice';
import Loading from '../../Loading';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function SectionThreeEditModel (props) {

    const navigate = useNavigate()
    const title = useRef(props.title)
    const from = useRef(props.from)
    const to = useRef(props.to)
    const [status, setStatus] = useState(props.open)
    const [mobile, setMobile] = useState('')
    const [password, setPassword] = useState('')
    let [check, setCheck] = useState(false)
    const [flag, setFlag] = useState()
    const [getmessage, setGetMessage] = useState(props.message)
    const dispatch = useDispatch()
    const { 
        message, 
        errorTitle,
        archiveSectionThreeLoading, 
        archiveSectionThreeSuccess,
    } = useSelector(state => state.sectionThree)
    const checkHandler = (e) => {
        setFlag(e.target.checked)
    }
    const editHandler = (event) => {
        event.preventDefault();
        const data = {
            'id': props.id,
            'title': title.current.value,
            'from': from.current.value,
            'to': to.current.value,
            '_method': 'PATCH'
        }
      
        dispatch(editSectionThree(data))
        
        
    }
    const closeButtonHandler = () => {
        setGetMessage('')
    }
    useEffect (() => { 
        setGetMessage(message)  
    },[archiveSectionThreeSuccess, message, flag])

    return (
        <Modal
            {...props}
            size=""
            aria-labelledby="contained-modal-title-vcenter"
            centered
            >
            <Modal.Header closeButton className='border-0' onClick={closeButtonHandler}>
                <Modal.Title id="contained-modal-title-vcenter">
               
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <>
            <div className="col-12 col-md-12 p-3 rounded kv-logo d-flex flex-column justify-content-center align-items-center">
                <div className="mb-5 text-center">
                    <h3 className='mb-3'>{props.header}</h3>
                    <small className="text-black-50 fw-bold fs-6">
                    کاربر گرامی برای ویرایش نام جدید انتخاب کنید
                    </small>
                </div>
                {/* Login Form */}
                <div className="col-12 col-md-10">
                    <div>
                        <div className='col-12 mb-3 input'>
                           <div className='rahpardaznet-edit-zonkan'>
                                <label>نام زونکن</label>
                                <input 
                                    autoFocus='true'
                                    type='text'
                                    defaultValue={props.title}
                                    ref={title} 
                                    className="form-control form-control-lg shadow-none" 
                                />
                                {
                                    (errorTitle) ? (
                                    <span className="help-block fw-bold d-inline-block mt-2">
                                        <small className='text-danger'>{ errorTitle }</small>
                                    </span>
                                ):''
                                }
                           </div>
                            <div className='rahpardaznet-edit-zonkan'>
                                <label>از شماره سند</label>
                                <input 
                                    autoFocus='true'
                                    type='text'
                                    defaultValue={props.from}
                                    ref={from} 
                                    className="form-control form-control-lg shadow-none" 
                                />
                            </div>
                            <div className='rahpardaznet-edit-zonkan'>
                                <label>از شماره سند</label>
                                <input 
                                    autoFocus='true'
                                    type='text'
                                    defaultValue={props.to}
                                    ref={to} 
                                    className="form-control form-control-lg shadow-none" 
                                    id='exampleInputMobile' 
                                    aria-describedby='mobileHelp' 
                                />
                            </div>
                           
                        </div>
                     
                       
                        <div className='col-12 border-top text-left pt-3'>
                            <button 
                                onClick={editHandler}
                                type="submit"
                                className="px-4 py-2 rahpardaznet-btn">
                                {'   ویرایش  '}
                            </button>
                        </div>
                      
                    </div>
                </div>
            </div>
            </>
            </Modal.Body>
    </Modal>
    )
}

export default SectionThreeEditModel;